// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__-i1fj","pageButtons":"Pagination_pageButtons__cYBTy","pageButton":"Pagination_pageButton__eTL3p","pageStats":"Pagination_pageStats__+oDi1"};